
let urlBase = location.href
let hosts = {}
if(urlBase.indexOf('haoojob')!=-1){
    hosts={
        lielang: 'https://app.haoojob.com/',
    }
}else{
    hosts={
        lielang: 'https://tx.haoojob.com/',
    }
}
import axios from 'axios'
class Api {
    async jobList (options = {}) {//职位列表
        let res = await axios.get(`${hosts.lielang}job/list`,{ params: options })
        return res.data.data
    }
    async jobInfo (options = {}) {//职位详情
        let res = await axios.get(`${hosts.lielang}job/info`,{ params: options })
        return res.data.data
    }

    async jobCode (options = {}) {//职位二维码
        let res = await axios.get(`${hosts.lielang}wxauth/get_job_unlimited`,{ params: options })
        return res.data.data
    }

    async userCode (options = {}) {//职位二维码
        let res = await axios.get(`${hosts.lielang}wxauth/get_unlimited`,{ params: options })
        return res.data.data
    }
    
    async companyList (options = {}) {
        let res = await axios.get(`${hosts.lielang}factory/list`,{ params: options })
        return res.data.data
    }
    async newList (options = {}) {
        let res = await axios.get(`${hosts.lielang}tutorial/list_official`,{ params: options })
        return res.data.data
    }
    async newDetail (options = {}) {
        let res = await axios.get(`${hosts.lielang}tutorial/info`,{ params: options })
        return res.data.data
    }

    // 地图
    async storeInfo (obj) {
        let res = await axios.get(`${hosts.lielang}store/map_info`,obj)
        return res.data.data
    }
    async groupMapInfo (obj) {
        let res = await axios.get(`${hosts.lielang}group/map_info`,obj)
        return res.data.data
    }

    async roleApplySave(obj){//入驻
        let res = await axios.post(`${hosts.lielang}role_apply/save`, obj)
        return res.data
    }

    async groupWebList (options = {}) {
        let res = await axios.get(`${hosts.lielang}group/web_list`,{ params: options })
        return res.data.data
    }
    
    async userList (options = {}) {
        let res = await axios.get(`${hosts.lielang}user/list`,{ params: options })
        return res.data.data
    }

    async cityList (options = {}) {//查询入驻信息
        let res = await axios.get(`${hosts.lielang}city/city_list`,{ params: options })
        return res.data.data
    }

    async getCountryData(obj){//查询全国城市数据
        let res = await axios.get(`https://restapi.amap.com/v3/config/district`,{params:obj})
        return res.data
    }

    async correlationList (options = {}) {//查询劳务公司关联的城市列表
        let res = await axios.get(`${hosts.lielang}city/correlation_list`,{ params: options })
        return res.data.data
    }

    async storeList (options = {}) {//查询劳务公司下的门店
        let res = await axios.get(`${hosts.lielang}store/list_statistics`,{ params: options })
        return res.data.data
    }
    
    async proxyerList (options = {}) {//查询劳务公司下的专员
        let res = await axios.get(`${hosts.lielang}store_user/list_statistics`,{ params: options })
        return res.data.data
    }
}
export default new Api()
